import { TimelineMax, Power3 } from "gsap";

export default class Meet {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.menu = this.element.querySelector(".meet__menu-list");
        this.menuItems = this.menu.querySelectorAll(".scroll__navigation-link");
        this.scrollToTop = this.element.querySelector(".btn--scroll-to-top");
        this.scrollWidth = this.menu.scrollWidth;
        this.locationHash = window.location.hash;

        this.init();
    }

    init() {
        this.bindEvents();

        this.animate();

        this.scrollToSectionByHash();
    }

    bindEvents() {
        this.menuItems.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();
                let target = e.currentTarget.dataset.scroll;
                let scrollDeep = document.querySelector(target).offsetTop;
                window.scrollTo({ top: scrollDeep, behavior: "smooth" });
            });
        });
        this.scrollToTop.addEventListener("click", e => {
            e.preventDefault();
            const element = document.getElementById("meet");
            const yOffset = -35;
            const y =
                element.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
        });
    }

    animate() {
        let tl = new TimelineMax();

        // const scrollWidth = this.menu.scrollWidth;

        return tl
            .staggerFromTo(
                [this.menu],
                0.7,
                { scrollLeft: 0 },
                {
                    scrollLeft: this.scrollWidth,
                    ease: Power3.easeInOut
                },
                0.05
            )
            .staggerFromTo(
                [this.menu],
                0.7,
                { scrollLeft: this.scrollWidth },
                {
                    scrollLeft: 0,
                    ease: Power3.easeInOut
                },
                0.05
            );
    }

    scrollToSectionByHash() {
        if (!this.locationHash) {
            return;
        }
        //let target = document.querySelector(this.locationHash);
        setTimeout(() => {
            let target = document.querySelector(this.locationHash);
            window.scrollTo({ top: target.offsetTop, behavior: "smooth" });
        }, 100);
    }
}
